// extracted by mini-css-extract-plugin
export var main = "page-default-module--main--1bFrw";
export var content = "page-default-module--content--nFs3Z";
export var preHeader = "page-default-module--preHeader--3BK1B";